import React from "react";
import Review from "./Review";
const ReviewList = props => {
  return <Review />;
};

export default ReviewList;
